import { lazy } from 'react';
import { withSuspense } from '@/hocs/withSuspense';

export const PrivateRoutesLazy = withSuspense(
  lazy(() => import('./private-routes').then((module) => ({ default: module.PrivateRoutes }))),
);
